import { CoreOverallLadder } from '../../collections';

/**
 * @desc Rankings
 * This Overall Ladderer Collection
 */
export class OverallLadder extends CoreOverallLadder {
	setLeagueOverallLadderUrl() {
		this.url = 'leagues_classic/show_overall_points';
		return this;
	}

	setOverallLadderUrl() {
		this.url = 'teams_classic/rankings';
		return this;
	}
}

export default OverallLadder;